import { Button } from "components/form";
import { getFromLocal } from "config/axiosInstance";
import useShimmer from "hooks/useShrimmer";
import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import {
  getSurveySummaryDetailsBarGraphApi,
  getSurveySummaryDetailsGraphApi,
} from "services/analysis";
import MySurveyShrimmer from "shrimmer/Survey/MySurveyShrimmer";
import { toast } from "sonner";
import MultiReportChart from "./MultiReportChart";
import { useTranslation } from "react-i18next";

const ReportGraphicalData = ({
  blockArray,
  titleArray,
  isNexDisable,
  blockOnChange,
  getParamsData,
  isPreDisabled,
  selectedBlock,
  selectedQuestion,
  questionIdForChart,
  questionChangeHandler,
}) => {
  //******************************* Handle All State *******************************//

  const [showShimmer, setShowShimmer] = useShimmer(MySurveyShrimmer);
  const [barChartGraphData, setBarChartGraphData] = useState();

  const [maxLabelLength, setMaxLabelLength] = useState(15);

  const [multiChartData, setMultiChartData] = useState();

  const [rangesArray, setRangesArray] = useState();

  const { t } = useTranslation();

  const [barChartData, setBarChartData] = useState({
    series: [],
    labels: [],
    colors: [],
  });

  const chartData = {
    options: {
      chart: {
        id: "basic-bar",
        toolbar: {
          show: false, // Disable the toolbar and menu
        },
      },
      xaxis: {
        categories: barChartData?.labels,
        // labels: {
        //   rotate: 0, // Keep labels horizontal
        //   formatter: (value) =>
        //     value?.length > maxLabelLength
        //       ? `${value?.slice(0, maxLabelLength)} .....`
        //       : value,
        // },
      },
      colors: barChartData?.colors,
      plotOptions: {
        bar: {
          borderRadius: 4,
          columnWidth: "40%", // Adjust width (e.g., "50%" or "70%")
        },
      },
    },

    series: [
      {
        name: selectedBlock || "",
        data: barChartData?.series || [],
      },
    ],
  };

  //******************************* Handle All Function ***************************//

  const setBarChartDataHandler = () => {
    if (barChartGraphData && Array.isArray(barChartGraphData)) {
      if (selectedQuestion?.questionType === "slider") {
        return;
      } else if (selectedQuestion?.questionType === "rating") {
        return;
      } else {
        const series = barChartGraphData?.map((item) => item?.value);
        const labels = barChartGraphData?.map((item) => item?.label);
        const colors = barChartGraphData?.map((item) => item?.colour);
        setBarChartData({ series, labels, colors });
      }
    }
  };

  useEffect(() => {
    setBarChartDataHandler();
  }, [barChartGraphData]);

  // question type sting handler
  const questionTypeStingHandler = (type) => {
    if (type === "slider") {
      return t("GRAPH_DATA.slider");
    }

    if (type === "image") {
      return t("GRAPH_DATA.pictureChoice");
    }

    if (type === "rating") {
      return t("GRAPH_DATA.rating");
    }

    if (type === "text") {
      return t("GRAPH_DATA.textField");
    }

    if (type === "rankorder") {
      return t("GRAPH_DATA.rankOrder");
    }

    if (type === "multiple") {
      return t("GRAPH_DATA.multipleChoiceQuestion");
    }
  };

  // get barChart Data handler
  const getQuestionBarChartDataHandler = async () => {
    try {
      // setModalChartData();
      setShowShimmer(true);
      const reqData = {
        token: getFromLocal(),
        questionId: questionIdForChart,
        surveyId: getParamsData?.surveyId,
      };

      const responseData = await getSurveySummaryDetailsBarGraphApi(reqData);

      const { status, message, data } = responseData;
      if (status === 200) {
        if (selectedQuestion?.questionType === "slider") {
          const ranges = data?.result?.rangeArray?.map((el) => {
            return {
              label: el?.label,
              color: el?.colour,
            };
          });

          setRangesArray(ranges);
          setBarChartGraphData(data?.result?.options);
        } else if (selectedQuestion?.questionType === "rating") {
          const ranges = data?.result?.rangeArray?.map((el) => {
            return {
              label: el?.label,
              color: el?.colour,
            };
          });

          setRangesArray(ranges);
          setBarChartGraphData(data?.result?.options);
        } else {
          setBarChartGraphData(data?.result);
        }
        // setModalChartData(data);
      } else {
        toast.error(message);
      }
    } catch (e) {
      console.log("Error:", e.message);
    } finally {
      setShowShimmer(false);
    }
  };

  // function for set slider and Rating chart data
  const ratingAndSliderTypeQuestionChartDataHandler = () => {
    if (selectedQuestion?.questionType === "slider") {
      if (barChartGraphData?.length > 0) {
        const options = barChartGraphData?.map((el) => el?.label);

        const dataSets = rangesArray?.map((range) => {
          return {
            label: range?.label,
            backgroundColor: range?.color,
            data: barChartGraphData?.reduce((acc, el) => {
              el?.ranges?.forEach((item) => {
                if (item?.label === range.label) {
                  // acc.push(
                  //   !item.percentage
                  //     ? Math.floor(Math.random() * 90) + 10
                  //     : item.percentage
                  // );
                  acc.push(item.percentage);
                }
              });
              return acc;
            }, []),
          };
        });

        const dataMain = {
          labels: options?.map((el) => el.substr(0, 25)),
          datasets: [...dataSets],
        };

        setMultiChartData({ ...dataMain });
      }
    }

    if (selectedQuestion?.questionType === "rating") {
      if (barChartGraphData?.length > 0) {
        const options = barChartGraphData?.map((el) => el?.label);

        const dataSets = rangesArray?.map((range) => {
          return {
            label: range?.label,
            backgroundColor: range?.color,
            data: barChartGraphData?.reduce((acc, el) => {
              el?.ranges?.forEach((item) => {
                if (item?.label === range?.label) {
                  // acc.push(
                  //   !item.percentage
                  //     ? Math.floor(Math.random() * 90) + 10
                  //     : item.percentage
                  // );
                  acc.push(item.percentage);
                }
              });
              return acc;
            }, []),
          };
        });

        const dataMain = {
          labels: options?.map((el) => el.substr(0, 25)),
          datasets: [...dataSets],
        };

        setMultiChartData({ ...dataMain });
      }
    }
  };

  useEffect(() => {
    if (barChartGraphData?.length > 0) {
      ratingAndSliderTypeQuestionChartDataHandler();
    }
  }, [barChartGraphData]);

  // useEffect for get selected Question chart Data
  useEffect(() => {
    if (questionIdForChart) {
      getQuestionBarChartDataHandler();
    }

    // eslint-disable-next-line
  }, [questionIdForChart]);

  const chartRenderAccordingTypeHandler = (type) => {
    if (type === "slider") {
      return multiChartData && <MultiReportChart chartData={multiChartData} />;
    } else if (type === "rating") {
      return multiChartData && <MultiReportChart chartData={multiChartData} />;
    } else {
      return (
        barChartGraphData?.length > 0 && (
          <Chart
            type="bar"
            options={chartData?.options || {}}
            series={chartData?.series || []}
          />
        )
      );
    }
  };

  //******************************** Handle HTML CODE *****************************//
  return (
    <div className="survey_response">
      <div className="book_list">
        {blockArray?.length > 0 &&
          blockArray?.map((el, i) => (
            <span
              key={`blockName${i + 1}`}
              style={{ cursor: "pointer" }}
              onClick={() => blockOnChange(el)}
              className={selectedBlock === el ? "blue mx-2" : "light mx-2"}
            >
              {el}
            </span>
          ))}
      </div>

      <p className="block_title">
        {/* <b>Title :-</b> */}
        {titleArray?.find((el) => el?.block === selectedBlock)?.title}
      </p>

      <div className="question">
        <h5>
          <span>{selectedQuestion?.questionNumber}</span>
          {questionTypeStingHandler(selectedQuestion?.questionType)}
        </h5>
        <h4>{selectedQuestion?.question || "-----"}?</h4>
      </div>

      {showShimmer || (
        <div className="chart_view">
          {chartRenderAccordingTypeHandler(selectedQuestion?.questionType)}

          {/* {selectedQuestion?.questionType === "slider" ||
          selectedQuestion?.questionType === "rating" ? (
            multiChartData && <MultiReportChart chartData={multiChartData} />
          ) : (
            <Chart
              type="bar"
              options={chartData?.options}
              series={chartData?.series || []}
            />
          )} */}
        </div>
      )}

      <div className="button_wrap">
        <Button
          className="light"
          isDisabled={isPreDisabled}
          onClick={() => questionChangeHandler("prev")}
        >
          {t("GRAPH_DATA.previousQuestion")}
        </Button>
        <Button
          isDisabled={isNexDisable}
          onClick={() => questionChangeHandler("next")}
        >
          {t("GRAPH_DATA.nextQuestion")}
        </Button>
      </div>
    </div>
  );
};

export default ReportGraphicalData;
